import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

/**
 * @deprecated Assays V1 Logic
 */
export const fetchAssayBaselineSummary = ({ iopath, baseline = {}, summarizer = {} }) => {
  const modifiedConfig = { summarizer, baseline };

  if (modifiedConfig?.baseline?.calculated?.fixed_window) {
    modifiedConfig.baseline.calculated.fixed_window.end = undefined;
    modifiedConfig.baseline.calculated.fixed_window.path = iopath;
    modifiedConfig.baseline.calculated.fixed_window.locations = modifiedConfig?.window?.locations || null;
  }

  const newBaselineObj = modifiedConfig.baseline?.calculated?.fixed_window
    ? { fixed_window: modifiedConfig.baseline.calculated.fixed_window }
    : { vector: modifiedConfig.baseline?.vector }

  const outputConfig = {
    summarizer: modifiedConfig.summarizer,
    baseline: newBaselineObj,
  }

  const body = JSON.stringify(outputConfig)

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/assays/summarize', fetchOptions)
}

/**
 * @deprecated Assays V1 Logic
 */
export const swrAssayBaselineSummarizer = (queryParams) => {
  const [summarizer, baseline, iopath] = queryParams;

  return fetchAssayBaselineSummary({ summarizer, baseline, iopath })
}

export default fetchAssayBaselineSummary;
